import { render, staticRenderFns } from "./faq-add.vue?vue&type=template&id=58adc13f&"
import script from "./faq-add.vue?vue&type=script&lang=js&"
export * from "./faq-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports